import { render, staticRenderFns } from "./BottomContent.vue?vue&type=template&id=16f7c10a&scoped=true"
import script from "./BottomContent.vue?vue&type=script&lang=js"
export * from "./BottomContent.vue?vue&type=script&lang=js"
import style0 from "./BottomContent.vue?vue&type=style&index=0&id=16f7c10a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f7c10a",
  null
  
)

export default component.exports